import { LandingButton, LandingCard } from "./LandingPrimitives";

export default function LandingFinalCta() {
  return (
    <section className="landing-section landing-section--cta">
      <div className="landing-shell landing-shell--narrow">
        <LandingCard glow className="landing-final-cta">
          <div className="landing-final-cta__wash" aria-hidden="true" />
          <div className="landing-final-cta__content">
            <p className="landing-section__eyebrow">Pornește simplu</p>
            <h2>Încearcă o aplicație pentru foi de parcurs online.</h2>
            <p>
              AIFoiParcurs completează foile de parcurs pentru firmă, validează datele și te ajută
              să păstrezi evidența în ordine.
            </p>
            <LandingButton href="/login">Testează gratuit</LandingButton>
            <p className="landing-note">Fără card - Activare instant</p>
          </div>
        </LandingCard>
      </div>
    </section>
  );
}
